import React, { useState } from "react";
import SalaryAdvancePresentational from "./salaryadvancepresentatonal";
import {
  getSalaryProfile,
  getSalaryAdvancedetails,
  getSalaryHistory,
  checkEligibilty,
} from "./utils";
import {
  notificationStrings,
  openNotificationWithIcon,
} from "../../common/notification-message/notification";

const SalaryAdvance = () => {
  const [salaryProfile, setSalaryProfile] = useState({
    cardSerialNumber: "",
    citizenId: "",
    corporateId: "",
    corporateName: "",
    employeeId: "",
    firstName: "",
    lastName: "",
    rmtProfileStatus: "",
    emiratesId: "",
    emiratesIdExpiryDate: "",
  });
  const [upData, setUpdata] = useState({
    citizenId: "",
    cardSerialNo: "",
    mobileNo: "",
  });
  const [dataLoading, setDataLoading] = useState({
    detailsLoading: false,
    reasonLoading: false,
  });
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [historyloading, sethistoryloading] = useState(false);

  const [resonEligibilty, setResonEligibilty] = useState([]);
  const [salaryAdvancedetails, setSalaryAdvancedetails] = useState({});
  const [SalaryHistory, setSalaryHistory] = useState([]);

  const mlist = [
    "JAN",
    "FEB",
    "MAR",
    "APR",
    "MAY",
    "JUN",
    "JUL",
    "AUG",
    "SEP",
    "OCT",
    "NOV",
    "DEC",
  ];
  const nuller = (obj) => {
    Object.keys(obj).map(function (key, index) {
      if (obj[key] == null) {
        obj[key] = "";
      }
    });
    return obj;
  };

  const handleChange = (value, type) => {
    const regex = RegExp(/^([0-9]+)$/);
    if (value === "" || regex.test(value)) {
      setUpdata({ ...upData, [type]: value });
    }
  };

  const checkEligibiltyreason = (employeeData) => {
    setDataLoading({ ...dataLoading, reasonLoading: true });
    checkEligibilty(employeeData)
      .then((res) => {
        setResonEligibilty(res.data);
        setDataLoading({ ...dataLoading, reasonLoading: false });
      })
      .catch((err) => {
        setDataLoading({ ...dataLoading, reasonLoading: false });
        setResonEligibilty({});
      });
  };

  const SalaryAddetails = (employeeData) => {
    let value = nuller(employeeData);
    if (value.citizenId === "") {
      openNotificationWithIcon(notificationStrings.error, "No Record Found");
    }

    if (employeeData.citizenId.length > 0) {
      setDetailsLoading(true);
      getSalaryAdvancedetails(employeeData)
        .then((res) => {
          setSalaryAdvancedetails(res.data.Details);
          setDetailsLoading(false);
        })
        .catch((err) => {
          setDetailsLoading(false);
          setSalaryAdvancedetails({});
        });
    }
  };

  const SalaryHistorylist = (employeeData) => {
    if (employeeData.citizenId.length > 0) {
      sethistoryloading(true);
      getSalaryHistory(employeeData)
        .then((res) => {
          let response = res.data.SalaryHistory;
          let final = response.map((item) => {
            let month = new Date(`${item.Month}/12/${item.Year}`);
            let monthlist = mlist[month.getMonth()];
            return { Amount: item.Amount, Month: monthlist, Year: item.Year };
          });
          setSalaryHistory(final);

          sethistoryloading(false);
        })
        .catch((err) => {
          sethistoryloading(false);
          setSalaryHistory([]);
        });
    }
  };
  const search = () => {
    setDataLoading({ ...dataLoading, profileDataloading: true });
    getSalaryProfile(upData)
      .then((res) => {
        setSalaryProfile(res.data);
        setDataLoading({ ...dataLoading, profileDataloading: false });
        SalaryAddetails(res.data);
        SalaryHistorylist(res.data);
        checkEligibiltyreason(res.data);
      })
      .catch((err) => {
        setDataLoading({ ...dataLoading, profileDataloading: false });
        setSalaryProfile({
          cardSerialNumber: "",
          citizenId: "",
          corporateId: "",
          corporateName: "",
          employeeId: "",
          firstName: "",
          lastName: "",
          rmtProfileStatus: "",
          emiratesId: "",
        });
      });
  };
  const clear = () => {
    setSalaryProfile({
      cardSerialNumber: "",
      citizenId: "",
      corporateId: "",
      corporateName: "",
      employeeId: "",
      firstName: "",
      lastName: "",
      rmtProfileStatus: "",
      emiratesId: "",
    });
    setUpdata({ mobileNo: "", cardSerialNo: "", citizenId: "" });
    setSalaryAdvancedetails({});
  };
  return (
    <>
      <SalaryAdvancePresentational
        {...{
          handleChange,
          salaryProfile,
          upData,
          clear,
          search,
          dataLoading,
          SalaryHistory,
          resonEligibilty,
          salaryAdvancedetails,
          detailsLoading,
          historyloading,
        }}
      />
    </>
  );
};
export default SalaryAdvance;
